import React from 'react';
import { useTheme } from '../context/ThemeContext';

export const MyEnAbLogo = ({ className = "w-48 h-14" }) => {
    const { theme } = useTheme();
    const textColor = theme === 'dark' ? '#FFFFFF' : '#09090b';

    return (
        <div className={`flex items-center ${className}`}>
            <svg viewBox="0 0 420 120" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
                <defs>
                    <linearGradient id="grad4" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#E40303" />
                        <stop offset="20%" stopColor="#FF8C00" />
                        <stop offset="40%" stopColor="#FFD700" />
                        <stop offset="60%" stopColor="#008026" />
                        <stop offset="80%" stopColor="#24408E" />
                        <stop offset="100%" stopColor="#732982" />
                    </linearGradient>
                </defs>

                <circle cx="55" cy="60" r="30" stroke="url(#grad4)" strokeWidth="8" fill="none" />
                <circle cx="55" cy="45" r="6" fill="url(#grad4)" />
                <path d="M55 50 L55 72 L68 85" stroke="url(#grad4)" strokeWidth="6" strokeLinecap="round" />

                <text x="110" y="70" fontSize="42" fontFamily="Arial, Helvetica, sans-serif" fontWeight="700" fill={textColor}>
                    MyEnAb
                </text>
            </svg>
        </div>
    );
};

export default MyEnAbLogo;

